/**
 * @fileoverview GET handler for the "/integrations/voucher_group/:id/:app_group_id/voucher_group_references" endpoint
 */
import { isIntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferencesResult } from "@dashboardApi/apis/integrationsVoucherGroupIdAppGroupIdVoucherGroupReferences/validators";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsVoucherGroupIdAppGroupIdVoucherGroupReferences } from "./constants";
import type { IntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferencesResult } from "./types";

export const getIntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferences = reactQueryFetcherAdapter(
  integrationsVoucherGroupIdAppGroupIdVoucherGroupReferences,
  (
    signal: AbortSignal,
    id: string,
    appGroupId: string
  ): Promise<IntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferencesResult> => {
    return fetch(`/integrations/voucher_group/${id}/${appGroupId}/voucher_group_references`, "GET", {}, { signal });
  },
  isIntegrationsVoucherGroupIdAppGroupIdVoucherGroupReferencesResult
);
